import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import { WysiwygAction } from '../../../adapter/wysiwyg-adapter.types';
import { Placeholder, PlaceholderId } from '../../placeholder';
import { PlaceholderService } from '../../placeholder.service';
import { ActionType, WysiwygPlaceholderAction } from '../wysiwyg-placeholder.types';

@Component({
  selector: 'rt-wysiwyg-placeholder-dropdown',
  styleUrls: ['./wysiwyg-placeholder-dropdown.component.less'],
  templateUrl: './wysiwyg-placeholder-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WysiwygPlaceholderDropdownComponent {
  @Input() public active: Placeholder;
  @Input() public placeholders: Placeholder[];

  @Output() public action: EventEmitter<WysiwygPlaceholderAction> = new EventEmitter();
  public filteredPlaceholders: Placeholder[];

  constructor(private placeholderService: PlaceholderService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.placeholders) {
      this.filteredPlaceholders = changes.placeholders.currentValue.filter(
        ({ id }: { id: PlaceholderId }) =>
          !this.placeholderService.deprecatedCollection.includes(id),
      );
    }
  }

  public deletePlaceholder(event: Event, placeholder: Placeholder) {
    event.stopPropagation();
    event.preventDefault();
    this.emitPlaceholderDelete(placeholder);
  }

  public emitPlaceholderChange(placeholder: Placeholder): void {
    this.action.emit(new WysiwygAction(ActionType.PlaceholderChange, placeholder));
  }

  public emitPlaceholderDelete(placeholder: Placeholder): void {
    this.action.emit(new WysiwygAction(ActionType.PlaceholderDelete, placeholder));
  }
}
